var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNetworkIt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.5 14.5h15v-10h-15zM19.5 2h-15A2.5 2.5 0 0 0 2 4.5v10A2.5 2.5 0 0 0 4.5 17h6.25v2.5h-2.5a1.25 1.25 0 0 0 0 2.5h7.5a1.25 1.25 0 0 0 0-2.5h-2.5V17h6.25a2.5 2.5 0 0 0 2.5-2.5v-10A2.5 2.5 0 0 0 19.5 2",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.16 6.813V12.5H8.992V6.813zm3.524 0V12.5h-1.168V6.813zm1.75 0v.917h-4.641v-.918z"
})));
export default SvgNetworkIt;